export default __webpack_public_path__ + "static/tabla-de-posiciones-mobile-87154f7ba65fe24859e30b2c967abc4e.svg";